import { useState } from 'react';
import { type ProductPromotion } from '@libs/common-next';
import type { EligiblePromotion } from '@libs/common-types';
import PromoItem from './PromoItem';
import OfferDetails from './OfferDrawer';
import { useDiscountDetailsQuery } from './hooks/useDiscountDetailsQuery';

type PromoListProps = {
    readonly promotions: ProductPromotion[] | EligiblePromotion[];
    readonly isCTEnabled: boolean;
};

function PromoListCT({
    promotions,
}: Readonly<{ promotions: EligiblePromotion[] }>) {
    const [selectedPromotion, setSelectedPromotion] =
        useState<EligiblePromotion | null>(null);

    const { data: discountDetails, isLoading } = useDiscountDetailsQuery(
        selectedPromotion?.promoKey
    );

    function handleDetailsClick(promotion: EligiblePromotion) {
        setSelectedPromotion(promotion);
    }

    function handleCloseOfferDetails() {
        setSelectedPromotion(null);
    }

    return (
        <div className="product-promotions-list">
            {promotions.map(promotion => (
                <PromoItem
                    key={promotion.promoId}
                    promoText={promotion.promoText}
                    onDetailsClick={() => handleDetailsClick(promotion)}
                    hasDetails={Boolean(promotion.promoKey)}
                />
            ))}
            <OfferDetails
                promotionName={selectedPromotion?.promoText}
                isOpen={Boolean(selectedPromotion)}
                discountDetails={discountDetails}
                isLoading={isLoading}
                onClose={handleCloseOfferDetails}
            />
        </div>
    );
}

function PromoListSFCC({
    promotions,
}: Readonly<{ promotions: ProductPromotion[] }>) {
    const [selectedPromotion, setSelectedPromotion] =
        useState<ProductPromotion | null>(null);

    function handleDetailsClick(promotion: ProductPromotion) {
        setSelectedPromotion(promotion);
    }

    function handleCloseOfferDetails() {
        setSelectedPromotion(null);
    }

    const discountDetails = selectedPromotion
        ? {
              termsAndConditions: selectedPromotion.details ?? '',
              description: '',
          }
        : null;

    return (
        <div className="product-promotions-list">
            {promotions.map(promotion => (
                <PromoItem
                    key={promotion.promotion_id}
                    promoText={promotion.callout_msg}
                    onDetailsClick={() => handleDetailsClick(promotion)}
                    hasDetails={Boolean(promotion.details)}
                />
            ))}
            <OfferDetails
                isOpen={Boolean(selectedPromotion)}
                promotionName={selectedPromotion?.callout_msg}
                discountDetails={discountDetails}
                isLoading={false}
                onClose={handleCloseOfferDetails}
            />
        </div>
    );
}

export default function PromoList({ promotions, isCTEnabled }: PromoListProps) {
    if (isCTEnabled) {
        return <PromoListCT promotions={promotions as EligiblePromotion[]} />;
    }

    return <PromoListSFCC promotions={promotions as ProductPromotion[]} />;
}
